import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  HelperViewStatus,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

interface Props {
  isOpen: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmExitModal',
  props: {
    isOpen: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,Modal, HelperViewStatus, ButtonContainer, ButtonPrimary, ButtonSecondary }
}

})